import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Upload, Trash2, FileText } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FileUploader({ purpose, relatedId, label = "Upload files" }) {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    const params = new URLSearchParams({ purpose });
    if (relatedId) params.set("related_id", relatedId);
    const { data } = await api.get(`/uploads?${params}`);
    setFiles(data);
  };
  useEffect(() => { load(); }, [purpose, relatedId]);

  const onChange = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true); setErr("");
    const fd = new FormData();
    fd.append("file", f);
    fd.append("purpose", purpose);
    if (relatedId) fd.append("related_id", relatedId);
    try {
      await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await load();
    } catch (e) { setErr(e.response?.data?.detail || e.message); }
    finally { setBusy(false); e.target.value = ""; }
  };
  const del = async (id) => {
    if (!window.confirm("Delete file?")) return;
    await api.delete(`/uploads/${id}`); load();
  };

  return (
    <div className="card" style={{ padding: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <div className="font-mono" style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--ink-mute)" }}>{label.toUpperCase()}</div>
        <label className="btn btn-ghost" style={{ cursor: "pointer", padding: "6px 12px", fontSize: 12 }}>
          <Upload size={14} /> {busy ? "Uploading…" : "Upload"}
          <input type="file" data-testid={`upload-${purpose}`} hidden onChange={onChange} disabled={busy} />
        </label>
      </div>
      {err && <div style={{ color: "var(--red)", fontSize: 12, marginBottom: 8 }}>{err}</div>}
      {files.length === 0 ? <div style={{ color: "var(--ink-mute)", fontSize: 13, padding: 8 }}>No files yet.</div> : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 6 }}>
          {files.map(f => (
            <li key={f.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 8, background: "var(--navy-900)", border: "1px solid var(--line)", borderRadius: 4 }}>
              <a href={`${BACKEND_URL}${f.url}`} target="_blank" rel="noreferrer" style={{ color: "var(--amber-400)", fontSize: 13, display: "flex", gap: 8, alignItems: "center", textDecoration: "none" }}>
                <FileText size={14} /> {f.filename} <span style={{ color: "var(--ink-mute)", fontSize: 11 }}>· {(f.size / 1024).toFixed(1)} KB</span>
              </a>
              <button onClick={() => del(f.id)} className="btn btn-ghost" style={{ padding: 6, color: "var(--red)" }}><Trash2 size={12} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
